import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import UserFilter from 'components/UserFilter';
import IconButton from 'components/IconButton';
import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import 'components/Filters/styles.css';
import './styles.css';

export const buildCustomerOptions = data =>
  data.results.map(customer => ({
    label: customer.fullName,
    value: customer.id,
    object: customer
  }));

interface CustomerFilterProps {
  fetchFunction: any;
  clearOption: any;
  onChange: any;
  customerRef: any;
}

// This component is almost the same as BookerFilter and CreatedByFilter.
// It is like that on purpose to be more easily mainatined in future
class CustomerFilter extends React.Component<CustomerFilterProps> {
  state = {
    sectionOpened: false
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  render() {
    return (
      <div
        className={classNames('FilterSection CustomerFilter', {
          'FilterSection--opened': this.state.sectionOpened
        })}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>Customer</div>
        </div>
        <div className="FilterSection__content">
          <UserFilter
            userRef={this.props.customerRef}
            fetchFunction={this.props.fetchFunction}
            buildOptions={buildCustomerOptions}
            clearOption={this.props.clearOption}
            filterBy={customerOption =>
              this.props.onChange(_.get(customerOption, 'value'))
            }
          />
        </div>
      </div>
    );
  }
}

export default CustomerFilter;
